<template>
  <v-row>
    <v-col>
      <v-text-field
        :label="$t('visitForm.organizeName')+':'"
        v-model="form.organization_name"
        outlined
        color="#2e8037"
      ></v-text-field>
      <v-text-field :label="$t('visitForm.email')+':'" v-model="form.email" type="email" outlined color="#2e8037"></v-text-field>
      <v-text-field :label="$t('visitForm.tel')+':'" v-model="form.phone" outlined color="#2e8037" hide-details></v-text-field>
      <div class="mb-5 mt-10">
        <span v-if="remark">{{ remark }}</span>
      </div>
      <v-textarea
        outlined
        name="input-7-4"
        :label="$t('visitForm.message')+':'"
        v-model="form.message"
        value
        color="#2e8037"
      ></v-textarea>
      <GreenButton :label="$t('visitForm.send')" @onPress="onSubmit" />
    </v-col>
  </v-row>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
export default {
  props: {
    remark: {
      type: String,
      default: null
    }
  },
  components: {
    GreenButton
  },
  data: () => ({
    form: {
      organization_name: "",
      email: "",
      phone: "",
      message: ""
    }
  }),
  methods: {
    async onSubmit() {
      this.$emit("onSubmit", this.form);
      await new Promise(x => setTimeout(x, 1000));
      this.form.email = "";
      this.form.phone = "";
      this.form.message = "";
      this.form.organization_name = "";
    }
  }
};
</script>

<style>
</style>
